// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reference-tooltip {
    position: fixed;
    z-index: 1000;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    width: 400px;
    max-width: 90vw;
    padding: 16px;
    pointer-events: auto;
    animation: tooltipFadeIn 0.2s ease-in-out;
}

.reference-tooltip-content {
    max-height: 400px;
    overflow-y: auto;
}

.reference-tooltip-header h3 {
    margin: 0 0 12px 0;
    font-size: 16px;
    color: #1a1a1a;
    font-weight: 600;
}

.reference-tooltip-body {
    font-size: 14px;
}

.reference-tooltip-body p {
    margin: 8px 0;
    color: #333;
}

.reference-tooltip-body strong {
    color: #1a1a1a;
}

.reference-tooltip-body a {
    color: #2563eb;
    text-decoration: none;
}

.reference-tooltip-body a:hover {
    text-decoration: underline;
}

.reference-tooltip-summary {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #eee;
    font-style: italic;
    color: #666;
}

@keyframes tooltipFadeIn {
    from {
        opacity: 0;
        transform: translateY(8px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ReferenceToolTip/ReferenceTooltip.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,aAAa;IACb,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ","sourcesContent":[".reference-tooltip {\r\n    position: fixed;\r\n    z-index: 1000;\r\n    background: white;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n    width: 400px;\r\n    max-width: 90vw;\r\n    padding: 16px;\r\n    pointer-events: auto;\r\n    animation: tooltipFadeIn 0.2s ease-in-out;\r\n}\r\n\r\n.reference-tooltip-content {\r\n    max-height: 400px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.reference-tooltip-header h3 {\r\n    margin: 0 0 12px 0;\r\n    font-size: 16px;\r\n    color: #1a1a1a;\r\n    font-weight: 600;\r\n}\r\n\r\n.reference-tooltip-body {\r\n    font-size: 14px;\r\n}\r\n\r\n.reference-tooltip-body p {\r\n    margin: 8px 0;\r\n    color: #333;\r\n}\r\n\r\n.reference-tooltip-body strong {\r\n    color: #1a1a1a;\r\n}\r\n\r\n.reference-tooltip-body a {\r\n    color: #2563eb;\r\n    text-decoration: none;\r\n}\r\n\r\n.reference-tooltip-body a:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n.reference-tooltip-summary {\r\n    margin-top: 12px;\r\n    padding-top: 12px;\r\n    border-top: 1px solid #eee;\r\n    font-style: italic;\r\n    color: #666;\r\n}\r\n\r\n@keyframes tooltipFadeIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(8px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
